import { render, staticRenderFns } from "./vue-countTo.vue?vue&type=template&id=246c63ba&"
import script from "./vue-countTo.vue?vue&type=script&lang=js&"
export * from "./vue-countTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports